import { render, staticRenderFns } from "./modelManage.vue?vue&type=template&id=4de40abd&scoped=true"
import script from "./modelManage.vue?vue&type=script&lang=js"
export * from "./modelManage.vue?vue&type=script&lang=js"
import style0 from "./modelManage.vue?vue&type=style&index=0&id=4de40abd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4de40abd",
  null
  
)

export default component.exports